import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Trash2 } from "lucide-react";
import { APP_VERSION } from "@/version";

const DataDeletion = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600 }}>🌿 Cilantro Alert</h2>
        <Button size="sm" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      </div>

      <div className="dashboard-content" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '0.5rem' }}>Data Deletion Request</h1>
          <p style={{ color: 'hsl(var(--muted-foreground))', fontSize: '0.9rem' }}>Cilantro Alert {APP_VERSION}</p>
        </div>

        <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader><CardTitle>How to request data deletion</CardTitle></CardHeader>
          <CardContent>
            <div style={{ lineHeight: '1.7', color: '#444' }}>
              <p style={{ marginBottom: '1rem' }}>
                You can request the deletion of your personal data at any time by sending an email to:
              </p>
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '1rem', marginBottom: '1rem', textAlign: 'center' }}>
                <a href="mailto:rudy@rm-worx.be?subject=Data%20Deletion%20Request%20-%20Cilantro%20Alert"
                   style={{ color: '#16a34a', fontWeight: 600, fontSize: '1.1rem' }}>
                  rudy@rm-worx.be
                </a>
              </div>
              <p style={{ marginBottom: '0.75rem' }}>In your email, please include:</p>
              <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>Subject: <strong>Data Deletion Request - Cilantro Alert</strong></li>
                <li>The email address associated with your account</li>
                <li>Which data you want deleted (account, contributions, or all data)</li>
              </ul>
            </div>
          </CardContent>
        </Card>

        <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader><CardTitle>What gets deleted</CardTitle></CardHeader>
          <CardContent>
            <div style={{ lineHeight: '1.7', color: '#444' }}>
              <p style={{ marginBottom: '0.75rem' }}>Upon request, we will delete:</p>
              <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>✅ Your account (name, email, profile picture)</li>
                <li>✅ Your login session data</li>
                <li>✅ Reviews and comments you submitted</li>
              </ul>
              <p style={{ marginBottom: '0.75rem' }}>The following may be retained anonymously:</p>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>⚠️ Product entries you added (without your name attached) — these contribute to the community database</li>
              </ul>
            </div>
          </CardContent>
        </Card>

        <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader><CardTitle>Response time</CardTitle></CardHeader>
          <CardContent>
            <p style={{ lineHeight: '1.7', color: '#444' }}>
              We will process your deletion request within <strong>30 days</strong> and confirm via email once completed.
            </p>
          </CardContent>
        </Card>

        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <a href="mailto:rudy@rm-worx.be?subject=Data%20Deletion%20Request%20-%20Cilantro%20Alert">
            <Button style={{ background: '#dc2626', color: 'white' }}>
              <Trash2 className="w-4 h-4 mr-2" />
              Send Deletion Request
            </Button>
          </a>
        </div>

        <div style={{ textAlign: 'center', marginTop: '2rem', color: 'hsl(var(--muted-foreground))', fontSize: '0.85rem' }}>
          <p>© 2026 RM-Worx BV · <span style={{ cursor: 'pointer', color: '#16a34a' }} onClick={() => navigate('/privacy')}>Privacy Policy</span></p>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
